import * as React from 'react';
import { ITranslatedComponent } from '../../redux/reducers/generalReducer';
import { translate } from 'react-i18next';
import { Card } from 'semantic-ui-react';
import { WorkflowOptionApprovalDto } from '../../services/Client';
import ColumnFactory from '../../services/ColumnFactory';

interface IApprovalBlockHeaderProps extends ITranslatedComponent {
    approval: WorkflowOptionApprovalDto;
}

const ApprovalBlockHeader: React.StatelessComponent<IApprovalBlockHeaderProps> = (props: IApprovalBlockHeaderProps) => {
    const {t, approval} = props;

    return (
        <Card fluid={true}>
            <Card.Content>
                <Card.Header>
                    {t("OPTION_CODE")}: {approval.optionCode}
                </Card.Header>
                <Card.Meta>
                    {t("OPTION_TYPE")}: {approval.optionType}
                </Card.Meta>
                {approval.modelyear && approval.modelyear.mj1 && approval.modelyear.mj4 &&
                    <Card.Meta>{t("MODELYEAR")}: {ColumnFactory.mj2str(approval.modelyear)}</Card.Meta>
                }
                {approval.typefamily && approval.typefamily.name &&
                    <Card.Meta>{t("TYPEFAMILY")}: {approval.typefamily.name}</Card.Meta>
                }
                {approval.cnr && approval.cnr.name &&
                    <Card.Meta>{t("CNR")}: {t(`GLOBAL:${approval.cnr.cnr}`)}</Card.Meta>
                }
                {approval.partNumber &&
                    <Card.Meta>{t("PARTNUMBER")}: {approval.partNumber}</Card.Meta>
                }
                <Card.Meta>
                    {t("OPTION_COMMENT")}: {approval.optionComment || t("EMPTY_OPTION_COMMENT")}
                </Card.Meta>
            </Card.Content>
            <Card.Content>
                <Card.Meta>
                    {t("WORKFLOW")}: {approval.workflow.name}
                </Card.Meta>
                <Card.Meta>
                    {t("STATUS_NOW")}: {approval.currentWorkflowStatus.name}
                </Card.Meta>
                <Card.Meta>
                    {t("STATUS_DESIRED")}: {approval.nextWorkflowStatus.name}
                </Card.Meta>
                <Card.Meta>
                    {approval.workflow.resetPointRejection
                        ? t("WORKFLOW:REJECT_TO_RESET_POINT_INFO")
                        : t("WORKFLOW:REJECT_TO_START_POINT_INFO")
                    }
                </Card.Meta>
            </Card.Content>
        </Card>
    );
};

export default translate(["APPROVAL_VIEW"])(ApprovalBlockHeader);



// WEBPACK FOOTER //
// ./src/views/ApprovalView/ApprovalBlockHeader.tsx